export const STUDIO_LAYOUT = {
  shellBg: '#f5f5f5',
  panelBorder: '#e6ebf1',
  panelRadius: 2,
  contentGap: 2,
  footerHeight: 32,
  topBarMinHeight: 52,
} as const;

export const STUDIO_PANEL = {
  leftWidth: 300,
  inspectorCollapsedRail: 56,
  propertiesWidth: 300,
  previewMinWidth: 280,
  previewMinHeight: 420,
} as const;

export const STUDIO_TYPO = {
  titleColor: '#012676',
  captionColor: 'text.secondary',
} as const;

